import { Type } from '@angular/core';

import { routerNavigatedAction } from '@ngrx/router-store';
import { createReducer, on } from '@ngrx/store';

import { isComponentRenderedByRouter } from '@fcom/common/utils';
import { OrderActions, SeatMapActions, ServicesActions } from '@fcom/common-booking/store';

import { MmbStage } from '../../enums';
import { StateActions } from '../actions';
import { StatusState } from '../../interfaces/store.interface';
import { ManageBookingViewRouteComponent } from '../../modules/view/routes/view-route.component';
import { ManageBookingPassengerDetailsRouteComponent } from '../../modules/view-passengers/routes/passenger-details-route.component';
import { AncillaryPurchaseCheckoutRouteComponent } from '../../modules/ancillary-purchase-checkout/routes/ancillary-purchase-checkout-route.component';
import { ManageBookingPurchaseSuccessRouteComponent } from '../../modules/purchase-success/routes/purchase-success-route.component';
import { ManageBookingReviewRouteComponent } from '../../modules/review/routes/review-route.component';
import { ManageBookingTravelPreparationsRouteComponent } from '../../modules/travel-preparations/routes/travel-preparations-route.component';
import { CheckInBoardingPassRouteComponent } from '../../modules/check-in/routes/check-in-boarding-pass-route.component';
import { CheckInFunnelRoutingComponent } from '../../modules/check-in/routes/check-in-funnel-routing.component';
import { CheckInConfirmationRouteComponent } from '../../modules/check-in/routes/check-in-confirmation-route.component';
import { ManageBookingCarRentalRouteComponent } from '../../modules/car-rental/routes/car-rental-route.component';

export const initialState: StatusState = {
  loading: false,
  error: null,
  stage: MmbStage.LOGIN,
  servicesDirty: false,
};

const eligibleComponents = [
  CheckInFunnelRoutingComponent,
  CheckInConfirmationRouteComponent,
  CheckInBoardingPassRouteComponent,
  ManageBookingViewRouteComponent,
  ManageBookingPassengerDetailsRouteComponent,
  ManageBookingCarRentalRouteComponent,
  ManageBookingTravelPreparationsRouteComponent,
  ManageBookingReviewRouteComponent,
  AncillaryPurchaseCheckoutRouteComponent,
  ManageBookingPurchaseSuccessRouteComponent,
];

const stateReducer = createReducer(
  initialState,
  on(routerNavigatedAction, (state, { payload }) => {
    if (
      !eligibleComponents.some(<T>(component: Type<T>) =>
        isComponentRenderedByRouter(payload.routerState.root, component)
      )
    ) {
      return initialState;
    }
    return state;
  }),
  on(SeatMapActions.setSeatForFlight, ServicesActions.setSelectionsForFragment, (state) => ({
    ...state,
    servicesDirty: true,
  })),
  on(OrderActions.resetCategoriesUpdating, OrderActions.clearCategoryUpdating, (state) => ({
    ...state,
    servicesDirty: false,
  })),
  on(SeatMapActions.resetSeatSelections, OrderActions.clearCategoryUpdating, (state) => ({
    ...state,
    servicesDirty: false,
  })),
  on(StateActions.setLoading, (state, { loading }) => ({
    ...state,
    loading,
  })),
  on(StateActions.setError, (state, { error }) => ({
    ...state,
    error,
  })),
  on(StateActions.clearError, (state) => ({
    ...state,
    error: null,
  })),
  on(StateActions.setStage, (state, { stage }) => ({
    ...state,
    stage,
  })),
  on(StateActions.clearStatusState, () => initialState)
);

export function reducer(state: StatusState, action: StateActions.StateActionsUnion): StatusState {
  return stateReducer(state, action);
}
